module.exports = __webpack_public_path__ + "img/wrapbg4.6de2c217.png";